module.exports = __webpack_public_path__ + "media/images/admin/icons/twitter-410a9d14144a810542330f7d951ff2cf.svg";